import { render, staticRenderFns } from "./userrole.vue?vue&type=template&id=63755c60&"
import script from "./userrole.vue?vue&type=script&lang=js&"
export * from "./userrole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports